import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { GlobalService } from "./global.service";
import { Block } from "app/interfaces/blocks";

@Injectable({
    providedIn: 'root'
})

export class HideUnusedBlocksService {
    private renderer: Renderer2;
        constructor(
            private globalService: GlobalService,
            private rendererFactory: RendererFactory2,
        ) {
            this.renderer = rendererFactory.createRenderer(null, null);
        }

    hideUnusedBlocks() {
        const field_datas = this.globalService.fields_data;
        if (Object.prototype.hasOwnProperty.call(field_datas, 'blocks')) {
            for (const key in field_datas['blocks']) {
                if (Object.prototype.hasOwnProperty.call(field_datas['blocks'], key)) {
                    const block: Block = field_datas['blocks'][key];
                    const uuid = block.uuid;
                    if (block?.type === 'image' && Object.prototype.hasOwnProperty.call(block, 'file')) {
                        const imageDom = document.querySelector(`.image-box-inner[uuid="${uuid}"]`);
                        if (imageDom && !block?.file) {
                            const parentContainer = imageDom.closest('.content-box-block');
                            this.renderer.addClass(parentContainer, 'hidden');
                        }
                    }else if (block?.type === 'attachment' && Object.prototype.hasOwnProperty.call(block, 'files')) {
                        const attachmentDom = document.querySelector(`.attachment-box-inner[uuid="${uuid}"]`);
                        if (attachmentDom && block?.files.length === 0) {
                            const parentContainer = attachmentDom.closest('.content-box-block');
                            this.renderer.addClass(parentContainer, 'hidden');
                        }
                    }else if (block?.type === 'upload-pdf' && block?.files.length === 0 && block?.is_parent === 1) {
                        const pdfBlock = document.querySelector(`.pdf-block-upload[uuid="${block.uuid}"]`);
                        if (pdfBlock) {
                            const parentContainer = pdfBlock.closest('.content-box-block');
                            this.renderer.addClass(parentContainer, 'hidden');
                        }
                    }else if (block?.type === 'content-library') {
                        const contentLibraryBlock = document.querySelector(`.content-library-modal-setting[uuid="${block.uuid}"]`);
                        if (contentLibraryBlock) {
                            const parentContainer = contentLibraryBlock.closest('.content-box-block');
                            this.renderer.addClass(parentContainer, 'hidden');
                        }
                    }
                }
            }
        }
    }
}